/* eslint-disable */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDropzone from 'react-dropzone';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import CloudDownload from '@material-ui/icons/CloudDownload';
import convertToCommandsArray from './convertToCommandsArray';
import convertToCommandsArrayWithoutHeader from './convertToCommandsArrayWithoutHeader';
import csvToJson from './utils/converter/csvToJson';
import excelToJson from './utils/converter/excelToJson';
import getExternalReferences from './utils/getExternalReferences';

import IsInStockDialog from './isInStockDialog/IsInStockDialog';
import SelectFormatDialog from './SelectFormatDialog';
import getItemEan from './utils/getItemEan';

import { displayInAppError } from '../../utils/toast/Toast';

import {
  setCommands,
  checkIfReferenceAlreadyExist,
  openDialogBindingOffer,
  openSelectFormatDialog,
  setUnknowDeliveryOffer,
  addEanFromStockManager
} from './actions';

const getColor = state => {
  if (state.isDragAccept) {
    return '#00e676';
  }
  if (state.isDragReject) {
    return '#ff1744';
  }
  if (state.isDragActive) {
    return '#2196f3';
  }
  return '#eeeeee';
};

const Container = styled.div`
  height: 200px;
  margin: 35px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props.state)};
  border-style: dashed;
  background-color: #fff;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
  text-align: center;
`;

const CustomPaper = styled(Paper)`
  padding: 2px;
`;

const Exemple = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

Exemple.Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 20px;
`;

Exemple.Icon = styled(CloudDownload)`
  font-size: 2.8em;
  margin-top: 8px
  margin-bottom: 15px;
`;

class Dropzone extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    acceptedFiles: [],
    openDialogIsInStock: false
  };

  onDrop = acceptedFiles => {
    const fileName = acceptedFiles[0].name;
    if (
      fileName.endsWith('.csv') ||
      fileName.endsWith('.xls') ||
      fileName.endsWith('.xlsx')
    ) {
      this.setState({
        acceptedFiles,
        openDialogIsInStock: true
      });
    } else {
      displayInAppError(
        'Format non supporté, veuillez importer un fichier au format suivant ( .xlsx, .xls, .csv )'
      );
    }
  };

  handleCloseDialogIsInStock = () => {
    this.setState({ openDialogIsInStock: false });
  };

  processing = () => {
    const { dispatchOpenSelectFormatDialog } = this.props;
    const file = this.state.acceptedFiles[0];
    const { name } = file;

    const reader = new FileReader();
    reader.onabort = () =>
      displayInAppError('La lecture du fichier a été interrompue');
    reader.onerror = () =>
      displayInAppError('La lecture du fichier a été interrompue');
    // Lecture du fichier
    reader.onload = () => {
      const currentFile = reader.result;
      let jsonFile;
      if (name.endsWith('.csv')) {
        jsonFile = csvToJson(currentFile, true);
      } else {
        jsonFile = excelToJson(currentFile);
      }
      // Convertion au format sympl
      if (jsonFile.length > 0) {
        const commandsArray = convertToCommandsArray(jsonFile);
        if (commandsArray) {
          const { symplFormatCommands, unknowDeliveryOffer } = commandsArray;
          this.next(symplFormatCommands, unknowDeliveryOffer);
        } else {
          dispatchOpenSelectFormatDialog(true);
        }
      } else {
        dispatchOpenSelectFormatDialog(true);
      }
    };
    if (name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  unknowFileType = fileFormat => {
    const file = this.state.acceptedFiles[0];
    const { name } = file;
    const reader = new FileReader();
    // Lecture du fichier
    reader.onload = () => {
      const readFile = reader.result;
      let jsonFile;
      if (name.endsWith('.csv')) {
        jsonFile = csvToJson(readFile, false);
      } else {
        displayInAppError('Format de fichier non reconnu');
      }
      // Convertion au format sympl
      if (jsonFile) {
        const commandsArray = convertToCommandsArrayWithoutHeader(
          jsonFile,
          fileFormat
        );
        const { symplFormatCommands, unknowDeliveryOffer } = commandsArray;
        this.next(symplFormatCommands, unknowDeliveryOffer);
      } else {
        displayInAppError(
          'Erreur lors de la lecture du fichier, veuillez vérifier son format'
        );
      }
    };
    if (name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  next = (symplFormatCommands, unknowDeliveryOffer) => {
    const {
      currentUser,
      dispatchAddEanFromStockManager,
      productBarcode,
      dispatchSetCommands,
      dispatchCheckIfReferenceAlreadyExist,
      dispatchOpenDialogBindingOffer,
      dispatchSetUnknowDeliveryOffer
    } = this.props;
    // Ajout des données dans le store redux
    dispatchSetCommands(symplFormatCommands);
    let itemEan = {};
    if (currentUser.company) {
      itemEan = getItemEan(symplFormatCommands, currentUser.company.id);
    }

    if (itemEan.products.length) {
      dispatchAddEanFromStockManager(productBarcode);
    }
    const externalReferences = getExternalReferences(symplFormatCommands);
    // Vérification au près du serveur si les référence sont déjà existante
    dispatchCheckIfReferenceAlreadyExist(externalReferences);

    if (unknowDeliveryOffer.length) {
      dispatchSetUnknowDeliveryOffer(unknowDeliveryOffer);
      dispatchOpenDialogBindingOffer(true);
    }
  };

  render() {
    const { openDialogIsInStock } = this.state;
    return (
      <div>
        <SelectFormatDialog unknowFileType={this.unknowFileType} />
        <IsInStockDialog
          isOpen={openDialogIsInStock}
          handleCloseDialogIsInStock={this.handleCloseDialogIsInStock}
          processing={this.processing}
        />
        <CustomPaper>
          <ReactDropzone onDrop={this.onDrop}>
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject
            }) => (
              <Container
                {...getRootProps()}
                state={{ isDragActive, isDragAccept, isDragReject }}
              >
                <input {...getInputProps()} />
                <p style={{ marginTop: 75 }}>
                  Déposer vos fichiers ici, ou cliquez pour sélectionner vos
                  fichiers
                  <br />
                  Formats supportés ( .xlsx, .xls, .csv )
                </p>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 15 }}
                >
                  Importer un fichier
                </Button>
              </Container>
            )}
          </ReactDropzone>
          <Exemple>
            <Exemple.Button
              onClick={() =>
                window.open(
                  'https://s3-eu-west-1.amazonaws.com/app.sympl.fr/public/Orders+template.xlsx'
                )
              }
            >
              <Exemple.Icon role="button" />
              <div>Télécharger le fichier excel de base</div>
            </Exemple.Button>
          </Exemple>
        </CustomPaper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.init.currentUser,
  productBarcode: state.init.productBarcode
});

const mapDispatchToProps = dispatch => ({
  dispatchAddEanFromStockManager: data =>
    dispatch(addEanFromStockManager(data)),
  dispatchSetCommands: data => dispatch(setCommands(data)),
  dispatchCheckIfReferenceAlreadyExist: data =>
    dispatch(checkIfReferenceAlreadyExist(data)),
  dispatchOpenDialogBindingOffer: open =>
    dispatch(openDialogBindingOffer(open)),
  dispatchOpenSelectFormatDialog: open =>
    dispatch(openSelectFormatDialog(open)),
  dispatchSetUnknowDeliveryOffer: offers =>
    dispatch(setUnknowDeliveryOffer(offers))
});

Dropzone.propTypes = {
  currentUser: PropTypes.object.isRequired,
  productBarcode: PropTypes.array,
  dispatchOpenSelectFormatDialog: PropTypes.func.isRequired,
  dispatchAddEanFromStockManager: PropTypes.func.isRequired,
  dispatchSetCommands: PropTypes.func.isRequired,
  dispatchCheckIfReferenceAlreadyExist: PropTypes.func.isRequired,
  dispatchOpenDialogBindingOffer: PropTypes.func.isRequired,
  dispatchSetUnknowDeliveryOffer: PropTypes.func.isRequired,
  openDialogIsInStock: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(Dropzone);
